import React, { ReactElement } from 'react';
import Modal, { ModalProps } from 'react-bootstrap/Modal';
import classNames from 'classnames';
import TopBorderBtn from '../TopBorderBtn';

type Props = {
  title?: string;
  headerBtn?: ReactElement | null;
};

const ModalWrapper: React.FC<Props & ModalProps> = ({ title = '', children, onHide, headerBtn, ...props }) => (
  <Modal backdrop="static" centered {...props} animation={false}>
    <Modal.Header
      className={classNames('d-flex px-2 py-1 border-0', {
        'justify-content-end': !title,
        'justify-content-between': title,
      })}
    >
      {title}
      {headerBtn}
      {props.closeButton === false ? null : <TopBorderBtn icon="close" className="mt-2" clickHandler={onHide} />}
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
  </Modal>
);

export default ModalWrapper;
